
import Servicetypeinfo from '@/components/service/newjoin/Servicetypeinfo.vue'
export default {
  components: { Servicetypeinfo },
  props: {
    servicetypedata: {
      type: Array,
      default: () => []
    },
    iss: {
      // true主要服务 false次要服务
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: '1'
    },
    p: {
      type: String,
      default: '主要服务类型'
    }
  },
  data() {
    return {
      dataone: this.servicetypedata.filter((item) => item.objectOrientedType == 1),
      datatwo: this.servicetypedata.filter((item) => item.objectOrientedType == 2),
      result: []
    }
  },
  methods: {
    init() {
      // this.result = []
      this.dataone = this.servicetypedata.filter((item) => item.objectOrientedType == 1)
      this.datatwo = this.servicetypedata.filter((item) => item.objectOrientedType == 2)
    },
    initdata() {
      console.log(123)
      this.result = []
    },
    servicedatafn(item) {
      // 选择主要服务
      this.result = [item]
      this.$emit('servicedatafn', item)
    },
    tabservice(item) {
      // 选择次要服务
      if (item.dis) return
      if (this.iss) {
        this.servicedatafn(item)
        return
      }
      if (this.result.some((r) => r.serviceCode == item.serviceCode)) {
        this.result.forEach((r, inx) => {
          if (r.serviceCode == item.serviceCode) {
            this.result.splice(inx, 1)
          }
        })
        this.$emit('subservicedatafn', this.result)
        return
      }
      if (this.result.length >= 2) {
        return this.$Toast.fail({
          message: this.$v('最多可选两个次要服务'),
          icon: 'none',
          duration: 2000,
          getContainer: '#service-type'
        })
      }
      this.result.push(item)
      this.$emit('subservicedatafn', this.result)
    }
  }
}
